<template>
    <div class="flex-1 p-2">
        <p class="my-4 py-2 border-b text-lg"><i class="fa fa-exchange-alt text-brand"></i> Transfer Requests</p>

        <div v-if="search_requests" class="w-full text-center py-8">
            <i class="fa fa-spin fa-circle-notch"></i> searching
        </div>

        <div class="flex-1 flex justify-center flex flex-col" v-else-if="transfer_requests.length == 0">
            <div class="bg-grey-lighter p-3 italic">
                <p>No Results found</p>
            </div>
        </div>

        <div v-else>
            <div class="flex md:flex-row flex-col flex-no-wrap p-2 border-b">
                <div class="flex flex-row flex-grow items-center">
                    <div class="flex flex-grow flex-col md:flex-row">
                        <div class="flex-grow w-48 truncate py-1 font-medium">Email</div>
                        <div class="flex-grow w-48 md:w-24 truncate py-1 font-medium">Created By</div>
                        <div class="flex-grow w-48 md:w-24 truncate py-1 font-medium">Created At</div>
                    </div>
                    <div class="flex flex-grow flex-col md:flex-row">
                        <div class="flex-grow py-1 w-48 md:w-24 font-medium">Consumed</div>
                        <div class="flex-grow py-1 w-48 md:w-24 font-medium">Consumed At</div>
                    </div>
                </div>
            </div>

            <div class="flex md:flex-row flex-col flex-no-wrap px-2 py-4 border-t border-b" 
                v-for="requests in transfer_requests" :key=requests.id>
                <div class="flex flex-row flex-grow items-center">
                    <div class="flex flex-grow flex-col md:flex-row">
                        <div class="flex-grow w-48 truncate py-1">{{requests.email}}</div>
                        <div class="flex-grow w-48 md:w-24 truncate py-1">{{getUser(requests.created_by_user_id)}}</div>
                        <div class="flex-grow w-48 md:w-24 truncate py-1">{{formatDate(requests.created_at)}}</div>
                    </div>
                    <div class="flex flex-grow flex-col md:flex-row">
                        <div class="flex-grow w-48 md:w-24 truncate py-1">
                            <p v-if="requests.is_consumed">
                                <i class="fa fa-check text-brand mb-1"></i> <span class="font-medium">Yes</span>
                            </p>
                            <p v-else>
                                <i class="fa fa-times text-brand mb-1"></i> <span class="font-medium">No</span>
                            </p>
                        </div>
                        <div class="flex-grow w-48 md:w-24 truncate py-1">{{formatDate(requests.consumed_at)}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ["users"],

  data() {
    return {
      transfer_requests: [],
      search_requests: true
    };
  },

  mounted() {
    this.getTransferRequests();

    this.$ebus.$on("refresh-transfer-requests", () => {
      this.getTransferRequests();
    });
  },

  methods: {
    getTransferRequests() {
      axios.get(`api/vaults/${this.$route.params.vault_id}/transfers`).then(({ data }) => {
        this.search_requests = false;
        this.transfer_requests = data;
      });
    },

    formatDate(date) {
      if (_.isNil(date)) {
        return "N/A";
      }
      let d = moment(date);
      return d.format("DD/MM/YYYY");
    },

    getUser(id) {
      let user = _.filter(this.users, { id: id });

      if (!_.isEmpty(user)) {
        return user[0].first_name + " " + user[0].last_name;
      }

      return "-";
    }
  }
};
</script>

<style>
</style>
